
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ProductSection',
  props: {
    factories: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baseUrl
    };
  }
});
